export default [
  {
    component: 'CNavItem',
    name: 'Dashboard',
    to: '/dashboard',
    icon: 'cil-speedometer',
  },
  {
    component: 'CNavTitle',
    name: 'Zarządzanie',
  },
  // {
  //   component: 'CNavGroup',
  //   name: 'Użytkownicy',
  //   to: '/base',
  //   icon: 'cil-puzzle',
  //   items: [
  //     {
  //       component: 'CNavItem',
  //       name: 'Accordion',
  //       to: '/base/accordion',
  //     },
  //   ],
  // },
  {
    component: 'CNavItem',
    name: 'Użytkownicy',
    to: '/users',
    icon: 'cil-user',
  },
  {
    component: 'CNavItem',
    name: 'Sentymenty',
    to: '/sentiments',
    icon: 'cil-qr-code',
  },
  {
    component: 'CNavItem',
    name: 'Subskrypcje',
    to: '/subscriptions',
    icon: 'cil-layers',
  },
  {
    component: 'CNavItem',
    name: 'Płatności',
    to: '/payments',
    icon: 'cil-money',
  },
  {
    component: 'CNavItem',
    name: 'Zamówienia',
    to: '/orders',
    icon: 'cil-notes',
  },
  // {
  //   component: 'CNavItem',
  //   name: 'Download CoreUI',
  //   href: 'http://coreui.io/vue/',
  //   icon: { name: 'cil-cloud-download', class: 'text-white' },
  //   _class: 'bg-success text-white',
  //   target: '_blank'
  // },
  // {
  //   component: 'CNavItem',
  //   name: 'Try CoreUI PRO',
  //   href: 'http://coreui.io/pro/vue/',
  //   icon: { name: 'cil-layers', class: 'text-white' },
  //   _class: 'bg-danger text-white',
  //   target: '_blank'
  // }
]
